import React from 'react';
import { Typography } from '@scale/scaleui';
import { InviteTool } from './InviteTool';
import { HostsTool } from './HostsTool';
import { RsvpUsers } from './RsvpUsers';

interface PeopleProps {
  invitedUsers: string[];
  setInvitedUsers: (ids: string[]) => void;
  audience: string | null;
  setAudience?: (id: string | null) => void;
  audienceBucket: number | null;
  setAudienceBucket?: (index: number | null) => void;
  invitedWorkerTeams: string[];
  setInvitedWorkerTeams: (ids: string[]) => void;
  invitedQualifications: string[];
  setInvitedQualifications: (ids: string[]) => void;
  invitedSquads: string[];
  setInvitedSquads: (ids: string[]) => void;
  hostedBy: string[];
  setHostedBy: (ids: string[]) => void;
  rsvpUsers?: string[];
  projectId?: string;
  disabled?: boolean;
}

// TODO: default state from props for editing existing sessions
export const People: React.FC<PeopleProps> = ({
  invitedUsers,
  setInvitedUsers,
  audience,
  setAudience,
  audienceBucket,
  setAudienceBucket,
  invitedWorkerTeams,
  setInvitedWorkerTeams,
  invitedQualifications,
  setInvitedQualifications,
  invitedSquads,
  setInvitedSquads,
  hostedBy,
  setHostedBy,
  rsvpUsers,
  projectId,
  disabled,
}) => {
  return (
    <div>
      <Typography.Subtitle3 className="text-neutral-600 mb-1">People</Typography.Subtitle3>
      <div className="ml-4">
        <InviteTool
          invitedUsers={invitedUsers}
          setInvitedUsers={setInvitedUsers}
          audience={audience}
          setAudience={setAudience}
          audienceBucket={audienceBucket}
          setAudienceBucket={setAudienceBucket}
          invitedWorkerTeams={invitedWorkerTeams}
          setInvitedWorkerTeams={setInvitedWorkerTeams}
          invitedQualifications={invitedQualifications}
          setInvitedQualifications={setInvitedQualifications}
          invitedSquads={invitedSquads}
          setInvitedSquads={setInvitedSquads}
          projectId={projectId}
          disabled={disabled}
        />
        <HostsTool hostedBy={hostedBy} setHostedBy={setHostedBy} disabled={disabled} />
        {!!rsvpUsers?.length && <RsvpUsers userIds={rsvpUsers} />}
      </div>
    </div>
  );
};
